import useRolePermissionServices from "./useRolePermissionServices";
import { useHierarchyService } from "./useHierarchyService";

import { IsBefore, IsToday, IsTodayOrBefore, IsLater } from "../utilities/DateHelper";
import _ from 'lodash'

const useActionMenuServices = ({performAction})=>{
    const {data:{CensusRoles}} = useRolePermissionServices();
    const {data:{selectedTreeNode}} = useHierarchyService();
    const node = selectedTreeNode;

    const GetCensusMenuItems = (data, filter, multipleActive)=>{      
        let items = []       
            if(!_.isNull(data))
            {      
                if(_.isEqual(data.occupancyStatus, "UNOCCUPIED") && _.isEqual(data.reservationStatus, "RESERVED") && CensusRoles.canAssignOrReserveBeds){
                    items = IsTodayOrBefore(filter.date) && !multipleActive?
                        [ { label: 'Remove Reservation', icon: 'fa fa-trash' ,command:(e)=>{ performAction(node, data, "REMOVE_RESERVE", "")  } },
                        { label: 'Assign Bed', icon: 'fas fa-edit', command:(e)=>{ performAction(node, data, "ASSIGN", `Assign Bed: ${node.label}`) } }]

                    :[ { label: 'Remove Reservation', icon: 'fa fa-trash' ,command:(e)=>{ performAction(node, data, "REMOVE_RESERVE", "")  } }]
                }
                else if(_.isEqual(data.occupancyStatus, "OCCUPIED") && CensusRoles.canAssignOrReserveBeds){
                    const moveTitle = _.isEqual(data.occupantType.code, "CLIENT")?`Move ${data.occupantType.name}: ${data.client.lastName}, ${data.client.firstName}` : `Move ${data.occupantType.name}: ${data.client.dependentName}`
                    const removeAssignmentLabel = _.isEqual(data.occupantType.code, "CLIENT")?`Remove Client` : `Remove Dependent`
                    items = []
                    items.push({ label: 'Edit Assignment', icon: 'fa fa-user-edit' ,command:(e)=>{ performAction(node, data, "EDIT_ASSIGN", `Edit Assignment: ${node.label}`)}})
                    data.latestAssignment && !IsLater(filter.date) && items.push({ label: `${removeAssignmentLabel}`, icon: 'fa fa-trash' ,command:(e)=>{ performAction(node, data, "REMOVE_ASSIGN", "")  } })
                    !IsLater(filter.date) && items.push( { label: `Move ${data.occupantType.name}`, icon: 'pi pi-sort-alt' ,command:(e)=>{ performAction(node, data, "MOVE", moveTitle)  } })
                   
                }
        }
        else{
           
            items = IsToday(filter.date) && !multipleActive?
            [   { label: 'Reserve Bed', icon: 'fas fa-plus' ,command:(e)=>{ performAction(node, data, "RESERVE", `Reserve Bed: ${node.label}`)  } },
                { label: 'Assign Bed', icon: 'fas fa-edit', command:(e)=>{ performAction(node, data, "ASSIGN", `Assign Bed: ${node.label}`) } }]

            :IsBefore(filter.date)? (!multipleActive && _.isNull(data))? [{ label: 'Assign Bed', icon: 'fas fa-edit', command:(e)=>{ performAction(node, data, "ASSIGN", `Assign Bed: ${node.label}`) } }]
            :[]
            :[{ label: 'Reserve Bed', icon: 'fas fa-plus' ,command:(e)=>{ performAction(node, data, "RESERVE", `Reserve Bed: ${node.label}`)  } }]
        }
        items.push({ label: 'View Bed Details', icon: 'fas fa-info-circle', command:(e)=>{ performAction(node, data, "VIEW_BED", `View Bed Details: ${node.label}`) } });
        items.push({ label: 'View Bed History', icon: 'fas fa-history', command:(e)=>{ performAction(node, data, "BED_HISTORY", `Bed History: ${node.label}`, 'bottom') } });
        !_.isNull(data) &&_.get(data.client, "id") && items.push({ label: 'View Client History', icon: 'fas fa-history', command:(e)=>{ performAction(node, data, "CLIENT_HISTORY", `Client Bed History: ${data.client.lastName}, ${data.client.firstName}`, 'bottom') } });
        //Check Permission  
        if(_.isEqual(selectedTreeNode.type, "BED")) {            
            (!CensusRoles.canAssignOrReserveBeds || !_.get(selectedTreeNode.data, "canAssign"))   &&_.remove(items, (i)=> {
                return _.isEqual(i.label, 'Assign Bed')
            });
            (!CensusRoles.canAssignOrReserveBeds || !_.get(selectedTreeNode.data, "canReserve"))   &&_.remove(items, (i)=> {
                return  _.isEqual(i.label, 'Reserve Bed');
            });
        }
       
        return items
    }

    return {data:{}, actions:{GetCensusMenuItems}}
}

export default useActionMenuServices;